<template>
  <div>
    <div class="user-form">
      <div class="success-title">{{$t("lang.userPage48")}}</div>
      <img src="~assets/images/ok.png" class="success-img">
      <div class="countdown">{{$t("lang.userPage49")}}</div>
      <router-link tag="div" class="btn" to="/login" >{{$t("lang.userPage45")}}</router-link>
    </div>
    <div class="app-bg"></div>
  </div>
</template>
<script>
export default {
  mounted() {
    this.forward();
  },
  methods: {
    forward() {
      let vm = this;
      setTimeout(function() {
        vm.$router.push({
          path: "/login"
        });
      }, 5000);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~styles/variables.scss";
@import "~styles/mixin.scss";
.user-form {
  width: 998px;
  height: 498px;
  position: absolute;
  border: 1px solid #dedede;
  top: 50%;
  left: 50%;
  margin: -250px 0px 0px -500px;
  background-color: $white;
  border-radius: 6px;
}
.success-title {
  margin: 30px 0px 50px;
  font-size: 18px;
  color: $gray;
  text-align: center;
}
.success-img {
  display: block;
  width: 219px;
  height: 201px;
  margin: 20px auto;
}
.btn {
  width: 300px;
  margin: 0 auto;
}
.countdown {
  text-align: center;
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/me/user-activate-success.vue